/*
 * Conflict resolution.
 */

/** Returns either the first non-null value, or merges both values using the provided function. */
export function mergeNullableValue<T>(mergeValue: (left: T, right: T) => T) {
  return (left: T | null, right: T | null): T | null => {
    if (left === null) {
      return right;
    }

    if (right === null) {
      return left;
    }

    return mergeValue(left, right);
  };
}
